export const SITE_BAR_LINK = 'site-bar-link';

export const SUBSCRIPTION_COST_SUMMARY_BUSINESS = 'subscription-cost-summary-business';
